import { BoxProps, ColorOptions, TextNewProps } from '@jfs/ui-new'
import { Colors } from '../../util/util'

export const shadow = {
  shadowColor: '#00000029' as ColorOptions,
  shadowOffset: {
    width: 0,
    height: 1,
  },
  shadowOpacity: 0.8,
  shadowRadius: 4,
  elevation: 3,
}

export const styles = {
  container: {
    shadowOffset: { width: 1, height: 1 },
    shadowRadius: 5,
    shadowColor: Colors.LIGHT_GREY,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: Colors.BORDER_COLOR,
    zIndex: 10,
    flex: 1,
    marginVertical: 16,
    marginHorizontal: 16,
    backgroundColor: 'WHITE',
    paddingHorizontal: 16,
    paddingVertical: 16,
    overflowY: 'auto',
  } as BoxProps,
  titleText: {
    fontSize: 16,
    color: 'BLACK_21' as ColorOptions,
    textAlign: 'left',
    fontFamily: 'jiotype-medium',
  } as TextNewProps,
  flexRowView: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    pb: 16,
  } as BoxProps,
  shareButton: {
    underlayColor: 'TRANSPARENT',
    borderWidth: 0.5,
    flexDirection: 'row',
    borderRadius: 4,
    justifyContent: 'center',
    alignItems: 'center',
    borderColor: 'LIGHTEST_GREY',
    pv: 3,
    ph: 10,
    ...shadow,
  } as BoxProps,
  topShareContainer: {
    alignSelf: 'flex-end',
    flexDirection: 'row',
    justify: 'center',
  } as BoxProps,
  shareText: {
    fontWeight: '600',
    fontSize: 12,
    color: 'BLUE',
  } as TextNewProps,
  downloadButton: {
    underlayColor: 'LIGHTEST_GREY',
    borderWidth: 0.5,
    flexDirection: 'row',
    borderRadius: 4,
    justifyContent: 'center',
    bg: 'BLUE',
    alignItems: 'center',
    borderColor: 'LIGHTEST_GREY',
    pv: 3,
    ph: 10,
    minWidth: 125,
    minHeight: 35,
    ...shadow,
  } as BoxProps,
  downloadText: {
    fontWeight: '600',
    fontSize: 12,
    color: 'WHITE',
  } as TextNewProps,
  loaderView: {
    pt: 40,
  } as BoxProps,
  qrMainView: () =>
    ({
      justify: 'flex-start',
      f: 1,
    } as BoxProps),
}
